import { store } from '@/app/store'
import { adminPortalApi } from '@/data/admin/api/admin_portal_api'
import type {
  SendPushToAllRequest,
} from '@/domain/push_notifications/entities/push_notification.entity'

export class PushNotificationsRtkDatasource {
  async sendToUser(userId: string, title: string, message: string): Promise<void> {
    const result = await store.dispatch(
      adminPortalApi.endpoints.sendPushToUser.initiate({ userId, title, message })
    )
    if (result.error) throw result.error
  }

  async sendToAll(payload: SendPushToAllRequest): Promise<void> {
    const result = await store.dispatch(
      adminPortalApi.endpoints.broadcastPush.initiate({
        title: payload.title,
        message: payload.message,
        userType: payload.userType,
      })
    )
    if (result.error) throw result.error
  }
}
